import { Box, Image, Dialog, Span, Button, Portal, CloseButton, Text, List, SimpleGrid, Heading, Strong } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useColorModeValue } from '../ui/color-mode';
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next';




const DialogContent = ({ children, ...props }) => {
  
  const { t } = useTranslation();
  return (
    <Dialog.Root
        closeOnInteractOutside
        placement={'center'}
        motionPreset="slide-in-bottom"
        size={'xl'}
      >
        <Dialog.Trigger asChild>
          {children}
        </Dialog.Trigger>
        <Portal>
          <Dialog.Backdrop filter={'blur(10px)'} />
          <Dialog.Positioner>
            <Dialog.Content rounded={24} p={{md: 6, base: 0}} >
              <Dialog.Header>
                <Dialog.Title fontFamily={'Onest'} letterSpacing={-0.8} textAlign={'center'}></Dialog.Title>
              </Dialog.Header>
              <Dialog.Body>

                <SimpleGrid columns={{ base: 1, md: 2 }} gap={6}>
                  <Box>
                    <Image rounded={'xl'} src={require('../../assets/Blog/hire.png')} alt="Internship" />
                  </Box>

                  <Box px={4} fontSize={'md'}>
                    <Heading fontFamily={'Onest'} fontSize={'4xl'} letterSpacing={-1.9} mb={4}>
              
                      <Span
                        bgGradient={'to-bl'}
                        gradientFrom={'purple.500'}
                        gradientTo={'blue.500'}
                        bgClip={'text'}
                        >
                          {t('offer_title')}
                        </Span>
                    </Heading>

                    <Text letterSpacing={-0.5}>{t('company_announcement')}</Text>
                    <Text mt={4} fontWeight={500} letterSpacing={-0.5}>{t('fields_label')}</Text>

                    <List.Root letterSpacing={-0.5} px={5} spacing={4} my={2}>
                      <List.Item>
                        {t('field_content_creation')}
                      </List.Item>
                      <List.Item>
                        {t('field_digital_marketing')}
                      </List.Item>
                      <List.Item>
                        {t('field_communication')}
                      </List.Item>
                    </List.Root>

                    <Text mt={4} fontWeight={500} letterSpacing={-0.5}>
                      {t('duration_label')} {t('duration_value')}
                    </Text>
                    <Text mt={2} fontWeight={500} letterSpacing={-0.5}>
                      {t('location_label')} {t('location_value')}
                    </Text>

                    <Text mt={4} letterSpacing={-0.5}>
                      {t('call_to_action')}
                    </Text>
                  </Box>
                </SimpleGrid>
              </Dialog.Body>
              <Dialog.Footer>
                <Dialog.ActionTrigger asChild>
                  <Button variant="outline">Télécharger la brochure</Button>
                </Dialog.ActionTrigger>
                <Button colorPalette={'purple'} variant={'surface'}>Postuler</Button>
              </Dialog.Footer>
              <Dialog.CloseTrigger asChild>
                <CloseButton rounded={'full'} size="sm" />
              </Dialog.CloseTrigger>
            </Dialog.Content>
          </Dialog.Positioner>
        </Portal>
      </Dialog.Root>
  )
}

const BotsAssistant = ({ setOpen }) => {

  const [isVisible, setIsVisible] = useState(false);
  const cardColor = useColorModeValue('white', 'gray.900')
  const MotionImage = motion.create(Image)



  const toggleVisibility = () => {
    // Show button if the user scrolls down more than 400 pixels
    if (window.pageYOffset > 600) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    // Cleanup the event listener when the component unmounts
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);


  return (
    <>

      <Box w={{md: '120px', base: '50px'}} className='group' visibility={isVisible ? 'visible' : 'hidden'} position={'fixed'} bottom={{md: 4, base: 14}} left={{md: 4, base: 'inherit'}} right={{md: 'inherit', base: 2}} zIndex={1000} display={{ base: 'block', md: 'block' }}>
        <Box _groupHover={{ opacity: 1 }} transition={'all 1.5s ease-in-out'} opacity={0} position={'absolute'} w={'210px'} top={-16} left={{md: '90%', base: 'inherit'}} right={{md: 'inherit', base: 2}} p={4} bg={cardColor} borderRadius={'xl'} boxShadow={'md'} mb={2}>
          <Box fontWeight={'bold'} mb={1} fontFamily={'Onest'}>Annonces !</Box>
          <Box fontSize={'sm'}>Nous avons des nouvelles pour vous ! &nbsp;
          <DialogContent>
            <Span color={'blue.500'} cursor={'pointer'}> découvrir.</Span>
          </DialogContent>
          </Box>
        </Box>
        <MotionImage
        animate={{
          y: [0, -20, 0],
          // S'écrase légèrement à l'atterrissage
        }}
        
        whileHover={{ y: 0, transition: { repeat: 'none' } }} // Animation au survol
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "circOut", // Accélération vers le bas plus naturelle
        }}  
        w={{md: '120px', base: '50px'}}  src={require('../../assets/vector/bots2.png')} alt="Bots"  />
      </Box>

      
      
    </>
  )
}

export default BotsAssistant